














































import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import FacilityCard from '@/components/ranking/FacilityCard.vue'
import LoadingCover from '@/components/globals/basics/Loading/LoadingCover.vue'
import { FacilityId, RankedFacility } from '@/core/Facilities'
import {
  listFavoriteFacilities,
  markFacilityAsFavorite,
  unmarkFacilityAsFavorite,
} from '@/core/Favorites'
import { Meta } from '@/tools/page'
import snackbar from '@/tools/snackbar'
import { getActivityFacilityRanking } from '@/core/Rankings'
import { ActivityId, Activity } from '@/core/Activities'
import dayjs from 'dayjs'

const PAGE_TITLE = '施設ランキング'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      'GYYMで利用できるフィットネスジムの施設ランキングです。今話題のジムや人気のプログラムを見つけて気軽にフィットネスを始めましょう！',
  },
]

export default Vue.extend({
  name: 'ActivityRankings',
  components: {
    PageDefaultLayout,
    LoadingCover,
    FacilityCard,
  },
  filters: {
    toFormattedDate(date: string): string {
      return date ? dayjs(date).format('M月D日') : ''
    },
  },
  data() {
    return {
      isFetching: false,
      isFetchingFavoritedFacilities: false,
      isRequestingFavorite: false,
      activity: {} as Activity,
      facilities: [] as RankedFacility[],
      aggregatedAt: '',
      favoritedFacilityIds: [] as FacilityId[],
    }
  },
  computed: {
    isLoggedIn(): boolean {
      return this.$store.getters['auth/isLogin']
    },
    isEmailVerified(): boolean {
      return this.$store.getters['auth/emailVerified']
    },
    activityId(): ActivityId {
      return Number(this.$route.params.activityId)
    },
  },
  async created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)

    await Promise.all([
      this.fetchActivityFacilityRanking(),
      this.isEmailVerified
        ? this.fetchFavoritedFacilities()
        : // ログインしていなければお気に入り情報は取得しない
          Promise.resolve(),
    ])

    this.$breadcrumbs.setParams({
      activity: this.activity.name,
    })

    this.$setPageTitle(`${this.activity.name}施設ランキング`)
  },
  methods: {
    async fetchFavoritedFacilities() {
      this.isFetchingFavoritedFacilities = true
      const favoriteFacilities = await listFavoriteFacilities()
      this.favoritedFacilityIds = favoriteFacilities.map(({ id }) => id)
      this.isFetchingFavoritedFacilities = false
    },
    async fetchActivityFacilityRanking() {
      try {
        this.isFetching = true
        const { activity, facilities, aggregatedAt } =
          await getActivityFacilityRanking(this.activityId)

        this.activity = activity
        this.facilities = facilities
        this.aggregatedAt = aggregatedAt
        this.isFetching = false
      } catch (e) {
        Sentry.captureException(e)
      }
    },
    async handleFavorited(facilityId: FacilityId, favorited: boolean) {
      // リクエスト中の場合は何もしない
      if (this.isRequestingFavorite) return

      // 未ログイン時はログイン画面に誘導するsnackbarを表示する
      if (!this.isLoggedIn) {
        snackbar({
          text: 'お気に入り登録にはログインが必要です',
          link: { to: '/login', text: 'ログインする' },
        })
        return
      }

      this.isRequestingFavorite = true

      try {
        // UIに先に反映する
        this.favoritedFacilityIds = favorited
          ? [...this.favoritedFacilityIds, facilityId]
          : this.favoritedFacilityIds.filter((id) => id !== facilityId)

        if (favorited) {
          await markFacilityAsFavorite(facilityId)
        } else {
          await unmarkFacilityAsFavorite(facilityId)
        }

        snackbar({
          text: `お気に入り${favorited ? '登録' : '解除'}しました。`,
        })
      } catch (e) {
        // リクエストに失敗したため、UIを元の状態に戻す
        this.favoritedFacilityIds = favorited
          ? this.favoritedFacilityIds.filter((id) => id !== facilityId)
          : [...this.favoritedFacilityIds, facilityId]

        snackbar({
          text: `お気に入り${favorited ? '解除' : '登録'}できませんでした。`,
        })
      } finally {
        this.isRequestingFavorite = false
      }
    },
  },
})
